module.exports = "/_next/static/images/add-user-success-4cb7038235bdf267c1cfa38179f6a5f5.svg";